module.exports = __webpack_public_path__ + "static/mattress-5-59ab240b11079f7ad27dea664835d52f.jpg";